import React from "react";

export default function Recomm({models}) {
    return (
        <>
            <div className="recom-slider-title">С этим товаром покупают</div>

            <div className="recom-slider">

                <div className="swiper-container recom-slider-container">
                    <div className="swiper-wrapper recom-slider-wrapper">


                        {models.map((el, index) => {
                            return <div key={index} className="swiper-slide recom-slider__slide">
                                <img src={el.imageUrl} className="recom-list-item__image"/>
                                <a className="btn-main-out recom-slider-buy" href={el.detailUrl}>Купить</a>
                                <div className="recom-list-item__name">{el.name}</div>
                            </div>
                        })}

                    </div>
                </div>

                <div className="swiper-button-next recom-slider-control recom-slider-button-next"/>
                <div className="swiper-button-prev recom-slider-control recom-slider-button-prev"/>
                <div className="recom-slider-pagination"/>
            </div>
        </>
    );
}